import { z } from 'zod';
export const knowledgePublishedArtifactCapability = 'knowledge.published-artifact.v1';
export const knowledgePublishedArtifactSlot = 'knowledge.published-artifact';
export const knowledgePublishedArtifactProviderId = 'knowledge.server.published-artifact';
export const knowledgePublishedArtifactRequestSchema = z.strictObject({
    consumerModuleId: z.string().regex(/^[a-z][a-z0-9-]*$/),
    requestedCapability: z.string().regex(/^[a-z][a-z0-9-]*\.[a-z][a-z0-9-]*\.v[1-9][0-9]*$/),
    resourceType: z.string().trim().min(1).max(100),
    resourceId: z.string().uuid(),
    documentId: z.string().uuid(),
});
export const knowledgePublishedArtifactResponseSchema = z.strictObject({
    state: z.literal('present'), capability: z.literal(knowledgePublishedArtifactCapability),
    documentId: z.string().uuid(), versionId: z.string().uuid(),
    versionNumber: z.number().int().positive(), title: z.string().min(1).max(200),
    documentType: z.enum(['sop', 'policy', 'safety', 'reference', 'faq', 'guide']),
    requiresAcknowledgement: z.boolean(), contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    publishedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=knowledge-published-artifact.contract.js.map